export enum DownloadMedicalCategory {
  OriginalRecord = 'original_record',
  ProviderNote = 'provider_note',
  ImagingResult = 'imaging_result',
  ProcedureNote = 'procedure_note',
  LabResult = 'lab_result',
  PathologyResults = 'pathology_results',
  Medications = 'medications',
  Vitals = 'vitals',
  Problems = 'problems',
  Encounters = 'encounters',
  AdditionalRecords = 'additional_record',
}
